import { MenuCard } from 'services/cmsContent/cmsContent.types';
import colors from 'style-utils/colors';
import media from 'style-utils/media-queries';
import { withOneLineEllipsis } from 'style-utils/overflow';
import { withSecondaryTypeface } from 'style-utils/text';
import styled, { StyledProps } from 'styled-components';

type MenuCardImageProps = StyledProps<{
  menuCard: MenuCard;
}>;

export const MenuCardLink = styled.a<MenuCardImageProps>`
  position: relative;
  display: block;
  width: 100%;
  height: 108px;
  border-radius: 10px;
  overflow: hidden;
  color: ${colors.white};

  ${({ menuCard }) => {
    const url = menuCard?.image ? `url("${menuCard?.image}")` : '';

    return `
      background: ${colors.greySuperlight} ${url} no-repeat center;
      background-size: cover;
    `;
  }};

  ${media.tablet`
    box-shadow: 0 2px 20px 0 rgba(0,0,0,0.08);
  `};

  ${media.desktop`
    ${({ menuCard }: MenuCardImageProps): string => {
      if (menuCard?.smallCard) {
        return `height: 76px;`;
      }

      return '';
    }}
  `}
`;

export const MenuCardText = styled.span<MenuCardImageProps>`
  position: absolute;
  z-index: 1;
  bottom: 16px;
  left: 12px;
  color: inherit;

  ${({ menuCard }): string => {
    if (menuCard.smallCard) {
      return `
        width: calc(100% - 24px);
        font-size: 14px;
        font-weight: bold;
        letter-spacing: 0.28px;
        text-align: center;
        ${withOneLineEllipsis};
      `;
    }

    return `
      display: inline;
      width: 90px;
      ${withSecondaryTypeface};
      font-size: 16px;
      font-weight: bold;
      letter-spacing: 0.48px;
    `;
  }}
`;
